import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faBell,
    faFutbol,
    faUsersCog,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faCircle,
    faExclamation,
    faCheck,
    faUpload,
    faCaretDown,
    faCaretUp,
    faEllipsisV,
    faInfoCircle,
    faSignOutAlt,
    faTimes,
    faBullseye,
    faEnvelopeOpenText,
    faArrowUp,
    faArrowDown,
    faFilter,
    faArrowLeft,
    faCompressAlt,
    faExpandAlt,
    faExchangeAlt,
    faPlus,
    faFile,
    faFileExport,
    faSnowflake,
    faHourglassHalf,
    faTint
} from "@fortawesome/free-solid-svg-icons";

import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

library.add(
    faBell,
    faFutbol,
    faUsersCog,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faCircle,
    faExclamation,
    faCheck,
    faUpload,
    faCaretDown,
    faCaretUp,
    faEllipsisV,
    faInfoCircle,
    faSignOutAlt,
    faTimes,
    faTrashAlt,
    faBullseye,
    faEnvelopeOpenText,
    faArrowUp,
    faArrowDown,
    faFilter,
    faArrowLeft,
    faCompressAlt,
    faExpandAlt,
    faExchangeAlt,
    faFile,
    faPlus,
    faFileExport,
    faSnowflake,
    faHourglassHalf,
    faTint
);
